import PropTypes from 'prop-types'
import { ReactTooltipStyled } from '../styled/typography/typographyExtentions'
import design from '../../static/images/questtypes/icon_design.svg'
import discovery from '../../static/images/questtypes/icon_discovery.svg'
import practice from '../../static/images/questtypes/icon_practice.svg'
import reflection from '../../static/images/questtypes/icon_reflection.svg'
import useLexicon from '../../hooks/useLexicon'

const QuestTypeIcon = ({
  quest,
  questType,
  displayTooltip,
  size,
  isStandalone,
  includeQuestNameInTooltip
}) => {
  const lexicon = useLexicon()

  const getIcon = () => {
    const _questType = !!quest.quest_type
      ? quest.quest_type.name.toLowerCase()
      : questType?.toLowerCase()

    switch (_questType) {
      case 'design':
        return design
      case 'discovery':
        return discovery
      case 'practice':
        return practice
      case 'reflection':
        return reflection
    }
  }

  const getRootStyle = () => {
    let style = {
      display: 'inline-block',
      height: `${size}px`,
      width: `${size}px`,
      zIndex: '12'
    }

    if (!isStandalone) {
      Object.assign(style, {
        position: 'absolute',
        right: '8px',
        bottom: '5px'
      })
    }

    return style
  }

  return !!quest.quest_type || !!questType ? (
    <div
      className="quest-type-icon-wrapper"
      style={getRootStyle()}
      data-tip={`${questType} ${lexicon.quest}${
        includeQuestNameInTooltip ? ': ' + quest.name : ''
      }`}
      data-for={`quest-${quest.id}-type`}
      data-place="right"
    >
      <img
        style={{
          height: '100%',
          width: '100%',
          boxShadow: 'none'
        }}
        alt={'type'}
        className="quest-type-icon"
        src={getIcon()}
      />

      {displayTooltip && !isStandalone && (
        <ReactTooltipStyled id={`quest-${quest.id}-type`} effect="solid" />
      )}
    </div>
  ) : null
}

QuestTypeIcon.defaultProps = {
  displayTooltip: true,
  includeQuestNameInTooltip: false,
  isStandalone: false,
  size: 26
}

QuestTypeIcon.propTypes = {
  quest: PropTypes.object,
  questType: PropTypes.string,
  displayTooltip: PropTypes.bool,
  includeQuestNameInTooltip: PropTypes.bool,
  isStandalone: PropTypes.bool,
  size: PropTypes.number
}

export default QuestTypeIcon
